export const StringComparator = (a, b) => {
    // Convert null or undefined to empty string
    a = a || "";
    b = b || "";

    // Perform a case-insensitive comparison
    return a.toLowerCase() === b.toLowerCase() ? 0 : a.toLowerCase() < b.toLowerCase() ? -1 : 1;
};